import * as React from 'react';

import { auth } from "../../firebase";
import { useDispatch } from 'react-redux';
import { setAnonymousUserZipCode } from '../actions/cartActions';
import { navigateTop, addRouteToBody } from '../routing/router-utils';
import Home from '@material-ui/icons/HomeRounded';
import Account from '@material-ui/icons/AccountCircleRounded';
import ChatRoundedIcon from '@material-ui/icons/ChatRounded';
// Re-Order 
// import ReceiptRoundedIcon from '@material-ui/icons/ReceiptRounded';
// Refer Friends
// import MoneyBagIcon from './MoneyBagIcon';
import SlideInCart from '../checkout/SlideInCart';
import DisplayModal from '../common/DisplayModal';
import AddressPrompt from '../address/AddressPrompt';
import SignIn from '../registration/SignIn';

import styles from './FixedFooterNav.module.css';

const FixedFooterNav = ({
  handleShowLogin,
  notificationIds=[],
  viewedIds=[]
}) => {

  const dispatch = useDispatch();

  // Login modal, used by Cart  
  const [showLoginModal, setShowLoginModal] = React.useState();
  
  // Address modal, used by the cart (anonymous users)
  const [showAddressModal, setShowAddressModal] = React.useState(false);
  const handleAddressUpdate = (zipCode) => {
    dispatch(setAnonymousUserZipCode(zipCode));
    setShowAddressModal(false)  
  };

  // force cart closed when another icon is clicked
  const [closeCart, setCloseCart] = React.useState();

  // click on non-cart icon closes open cart
  const handleOpenCart = (event) => {
    const isBagClick = !!event.target.closest('#ftrBagIcon');
    if (!isBagClick) {
      setCloseCart(true);   
    } 
  } 

  const defaultIconStyle = {
    color: 'var(--zrDarkBlue)',
    backgroundColor: 'white',
    width: 33,
    height: 33,
    lineHeight: '33px',
    verticalAlign: '-8px',
    textAlign: 'center'
  }

  const avatarIconStyle = {
    color: 'var(--zrDarkBlue)',
    backgroundColor: 'white',
    width: 30,
    height: 30,
    lineHeight: '30px',
    verticalAlign: '-8px',
    textAlign: 'center'
  }
  
  // Handle initial footer load
  React.useEffect(() => {
    addRouteToBody();
  }, []);  

  // Handle notification count
  const [unRead, setUnRead] = React.useState(0);
  React.useEffect(() => {
    const unReadCount = notificationIds.length - viewedIds.length;
    if ( unReadCount !== unRead) {
      setUnRead(unReadCount);
    }
  }, [notificationIds.length, viewedIds.length, unRead])

  const avatarClick = () => {
    if (window.location.pathname !== '/your/account') {
      if (auth.currentUser && !auth.currentUser.isAnonymous) {
        navigateTop('/your/account');
      } else {
        setShowLoginModal(true);
      }
    }
  };

  const bagClick = () => {
    // Undo any forced cart closing
    if (closeCart) {
      setCloseCart(false);
    }
  }

  const homeClick = () => {
    if (window.location.pathname !== '/') {
      navigateTop('/');
    }  
  };

  /*
  const referralClick = () => {
    // TODO: tracking
    navigateTop('/referralCode');
  };
  */

  return (
    <>
      {/* id is used to hide in reg flow */}
      <div id="footerNav" className={styles.fixedFooterNav} onClick={handleOpenCart}>
        <div className={`${styles.navItem} ${styles.homeIcon}`} onClick={homeClick}>
          <Home style={defaultIconStyle} />
          <div className={styles.navLabel}>Home</div>
        </div>
        <div id="ftrBagIcon" className={`${styles.navItem} ${styles.bagIcon}`} onClick={bagClick}>
          <SlideInCart 
            handleShowLogin={handleShowLogin}
            handleShowAddressPrompt={() => setShowAddressModal(true)}
            forceClose={closeCart} />
          <div className={styles.navLabel}>My Bag</div>
        </div>
        {/*
          <div className={`${styles.navItem} ${styles.referIcon}`} onClick={referralClick}>
            <MoneyBagIcon />
            <div className={styles.navLabel}>Rewards</div>
          </div>
        */}
        <div className={`${styles.navItem} ${styles.avatarIcon}`} onClick={avatarClick}>
          <Account style={avatarIconStyle} />
          <div className={styles.navLabel}>Account</div>
          { unRead > 0 && 
            <div className={styles.unReadCount}>{unRead}</div>
          }
        </div>
  
        {/* chat link id set in index.html */} 
        <div id="zr_chat_link" className={`${styles.navItem}`}> 
          <ChatRoundedIcon style={defaultIconStyle} />
          <div className={styles.navLabel}>Chat</div>
        </div>  

      </div>
      {/* TODO: combine with checkout login modal - with navigate param */}
      {/* NOTE: /your/account is now a protected route and handles Log In */}
      { showLoginModal && 
        <DisplayModal title="Sign In" showAboveNav closeFn={() => setShowLoginModal(false)}>
          <SignIn withHeader={false} navigateTo="/your/account" closeFn={() => setShowLoginModal(false)}/>
        </DisplayModal>
      }
      { showAddressModal &&  
        <DisplayModal title="Your Address" closeFn={() => setShowAddressModal(false)}>
          <AddressPrompt onComplete={(zipCode) => handleAddressUpdate(zipCode)} />
        </DisplayModal>
      }
    </> 
  );
};

export default FixedFooterNav;